import { withInstall } from './utils'
import Select from './google-translate-select.vue'

export const GoogleTranslateSelect = withInstall(Select)
export default GoogleTranslateSelect

export * from './types/props'
